import $ from 'jquery';
import { toggleButtonLoader } from '../../../utils/button-loader';
import { DokobitError } from '../../../types/dokobit-errors';
const ELEMENT_SELECTOR = '.js__age-verification-name-mismatch-modal';
export class AgeVerificationNameMismatchModal {
    static $element;
    static $description;
    static $confirmAction;
    static $cancelAction;
    static $alert;
    static init() {
        this.$element = $(ELEMENT_SELECTOR);
        this.$description = $(`${ELEMENT_SELECTOR}-description`);
        this.$confirmAction = $(`${ELEMENT_SELECTOR}-confirm`);
        this.$cancelAction = $(`${ELEMENT_SELECTOR}-cancel`);
        this.$alert = $(`${ELEMENT_SELECTOR}-alert`);
        this.bindEvents();
    }
    static updateDescription(oldName, newName) {
        this.$description.html(this.$description.data('content').replace('%old_name%', oldName).replace('%new_name%', newName));
    }
    static show() {
        this.$element.modal({
            backdrop: 'static',
            keyboard: false,
        });
    }
    static bindEvents() {
        this.$confirmAction.on('click', event => {
            this.handleConfirmAction(event);
        });
        this.$cancelAction.on('click', event => {
            this.handleCancelAction(event);
        });
    }
    static handleConfirmAction(event) {
        event.preventDefault();
        const $target = $(event.currentTarget);
        toggleButtonLoader($target, true);
        this.$cancelAction.addClass('disabled');
        this.$alert.hide();
        $.post($target.attr('href')).then(data => {
            window.location.assign(data.redirect_url);
        }, () => {
            toggleButtonLoader($target, false);
            this.$cancelAction.removeClass('disabled');
            this.$alert.show();
        });
    }
    static handleCancelAction(event) {
        event.preventDefault();
        const $target = $(event.currentTarget);
        toggleButtonLoader($target, true);
        this.$confirmAction.addClass('disabled');
        this.$alert.hide();
        $.post($target.attr('href')).then(() => { }, data => {
            const response = data.responseJSON;
            if (response.error === DokobitError.NameMismatchCancel || response.error === DokobitError.Lockdown) {
                window.location.assign(response.redirect_url);
                return;
            }
            toggleButtonLoader($target, false);
            this.$confirmAction.removeClass('disabled');
            this.$alert.show();
        });
    }
}
